module.exports = __webpack_public_path__ + "dea3d6cbbdde6e550c782d0491f93b2c.svg";